import { z } from 'zod';
import { MODULES } from './entities.js';
import { FieldDefinitionInput, LinkDefinitionInput } from './fields.js';
import { RuleInput } from './rules.js';
import { SavedReportInput } from './reports.js';
/**
 * A preset is an opinion: a bundle of modules, fields, links, rules, services,
 * reports and terminology for a kind of business. Applying a preset materializes
 * these as ordinary tenant rows tagged with origin = "preset:<key>@<version>".
 * Tenant edits layer on top; re-applying a newer version only adds what is
 * missing and never overwrites rows the tenant has changed.
 */
export const ServiceSeed = z.object({
    name: z.string(),
    description: z.string().optional(),
    category: z.string().optional(),
    unit: z.string().default('each'),
    default_price: z.number().nonnegative(),
    taxable: z.boolean().default(true),
    duration_minutes: z.number().int().positive().optional(),
});
export const PresetDefinition = z.object({
    modules: z.array(z.enum(MODULES)).min(1),
    terminology: z.record(z.string(), z.object({ singular: z.string(), plural: z.string() })).default({}),
    settings: z
        .object({
        tax_rate: z.number().min(0).max(100).optional(),
        tax_label: z.string().optional(),
        payment_terms_days: z.number().int().min(0).max(365).optional(),
        default_appointment_minutes: z.number().int().positive().optional(),
        invoice_notes: z.string().optional(),
    })
        .default({}),
    services: z.array(ServiceSeed).default([]),
    fields: z.array(FieldDefinitionInput).default([]),
    links: z.array(LinkDefinitionInput).default([]),
    rules: z.array(RuleInput).default([]),
    reports: z.array(SavedReportInput).default([]),
});
//# sourceMappingURL=presets.js.map